/**
 * @generated SignedSource<<f31671ff3fe11c23e9aab12e1a1a7774>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PaymentLinkType = "CHARGE" | "CHECKOUT" | "PIX_AUTOMATIC" | "PIX_AUTOMATIC_CHECKOUT" | "STATIC_QR_CODE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Payment_paymentLink$data = {
  readonly charge: {
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCharge_charge">;
  } | null | undefined;
  readonly checkout: {
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckout_checkout">;
  } | null | undefined;
  readonly paymentSubscription: {
    readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomatic_subscription" | "PaymentProvider_subscription">;
  } | null | undefined;
  readonly pixQrCode: {
    readonly " $fragmentSpreads": FragmentRefs<"PaymentQrCode_pixQrCode">;
  } | null | undefined;
  readonly type: PaymentLinkType | null | undefined;
  readonly " $fragmentType": "Payment_paymentLink";
};
export type Payment_paymentLink$key = {
  readonly " $data"?: Payment_paymentLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"Payment_paymentLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Payment_paymentLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Charge",
      "kind": "LinkedField",
      "name": "charge",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCharge_charge"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PixQrCode",
      "kind": "LinkedField",
      "name": "pixQrCode",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentQrCode_pixQrCode"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Checkout",
      "kind": "LinkedField",
      "name": "checkout",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCheckout_checkout"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentSubscription",
      "kind": "LinkedField",
      "name": "paymentSubscription",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentPixAutomatic_subscription"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentProvider_subscription"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentLink",
  "abstractKey": null
};

(node as any).hash = "119c039ee9e3a15549a6f84ac59e613b";

export default node;
